<mat-toolbar class="toolbar">
  <app-menu></app-menu>
  <span><app-menutitle></app-menutitle></span>
  <span style="width: 100px;">
  <mat-grid-list cols="2">
    <mat-grid-tile>
      <app-sync></app-sync>
</mat-grid-tile
    >
    <mat-grid-tile
      ><img
        src="../assets/tm_logo.jpg"
        alt="Timing.Mobi"
        class="logo"
    /></mat-grid-tile>
  </mat-grid-list></span>
</mat-toolbar>
<router-outlet></router-outlet>
